const cmsComponents = {
    IMAGE_TEXT_HYPERLINK: 'Bridge_Image_Text_Hyperlink',
    HEADER_TEXT: 'Bridge_Header_Text',
    LOADING_BOX: 'Bridge_Loading_Box',
    NEED_HELP: 'Bridge_Need_Help'
};

export default cmsComponents;
